// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Leve2QuoteType } from "../../Utils/Enums/Constants.js";

export let Level2Type =
{
    /// <summary>
    /// Коллекция бидов - сортировка по убыванию
    /// </summary>
    Bids: 0,
    /// <summary>
    /// Коллекция асков - сортировка по возрастанию
    /// </summary>
    Asks: 1
}
export let CompareType =
{
    Price: 0,
    PriceSize: 1,
    PriceTimeSize: 2
}
export let Filter =
{
    None: 0,
    MinusOne: 1,
    Time: 2,
    Size: 4
}
export let Level2Collection = function (si, l2Type)
{
    this.Level2Type = l2Type;
    this.SpreadItem = si;
    this.comparer = new Level2ItemComparer(this.Level2Type === Level2Type.Bids);

    var ins = si ? si.SpreadInstrument : null;
    this.instrumentPrecision = ins === null ? -1 : ins.getPrecision();
    this.reverse = this.Level2Type === Level2Type.Bids;

    this.topLevelItem = null;
    this.change = false;

    this.itemsArr = Array();
    this.items = new Object();
}

Level2Collection.Synchronized = function (si, l2Type)
{
    let l2Collect = new Level2Collection(si, l2Type);
    l2Collect.Synchronized = true;
    return l2Collect;
}


Level2Collection.prototype.Clear = function ()
{
    this.itemsArr = Array();
    this.items = new Object();
}

Level2Collection.prototype.Add = function (quoteMsg)
{
    // Добавление в список

    // Проверка цены, нужно ли удалить запись из таблицы
    let needToBeRemoved = (isNaN(quoteMsg.Size)) || quoteMsg.Closed;

    let topLevel2QuoteWasChanged = false;

    if (needToBeRemoved)
    {
        if (this.items[quoteMsg.MMID])
            delete this.items[quoteMsg.MMID];

        //
        // Generate level1 from level2
        // 
        // if (Utils.GenerateLevel1QuoteFromLevel2)
        // {
        //     if (this.topLevelItem != null && this.topLevelItem.MMIDs.Contains(quoteMsg.MMID))
        //     {
        //         this.change = true;
        //         this.topLevelItem = this.GetTopAggregatedQuote(this.GetSortedList(), this.instrumentPrecision);
        //         topLevel2QuoteWasChanged = true;
        //     }
        // }
    }
    else
    {
        let it = new Level2Item(quoteMsg, this.instrumentPrecision);
        this.items[quoteMsg.MMID] = it;

        //
        // Generate level1 from level2
        // 
        // if (Utils.GenerateLevel1QuoteFromLevel2)
        // {
        //     // 2. Обновилась та котриовка, которая была лучшей - занулим
        //     if (this.topLevelItem != null && (this.topLevelItem.MMIDs.indexOf(quoteMsg.MMID) >= 0))
        //     {
        //         this.topLevelItem = null;
        //         topLevel2QuoteWasChanged = true;
        //     }

        //     // 1. первая, выбирать не из чего - используем её
        //     if (this.topLevelItem == null && Object.keys(items).length === 1)
        //     {
        //         this.topLevelItem = it.Copy();
        //         this.topLevelItem.MMIDs = [it.Quote.MMID];
        //         topLevel2QuoteWasChanged = true;
        //     }
        //     else
        //     {
        //         // 3. Есть котировка - сравнение
        //         if (this.topLevelItem != null)
        //         {
        //             let res = this.topLevelItem.CachedRoundPrice - it.CachedRoundPrice;

        //             let compareRes;
        //             if (res <= -0.000000001)
        //                 compareRes = reverse ? 1 : -1;
        //             else if (res >= 0.000000001)
        //                 compareRes = reverse ? -1 : 1;
        //             else
        //                 compareRes = 0;

        //             if (compareRes > 0)
        //             {
        //                 this.topLevelItem = it.Copy(); //TODO: м.б можно сделать сокращенное копирование, чтобы не копировать все филды
        //                 this.topLevelItem.MMIDs = [it.Quote.MMID];
        //                 topLevel2QuoteWasChanged = true;
        //             }
        //             else if (compareRes == 0) //hsa: цена у разных котировок может совпадать, в этом случае изменяем объем
        //             {
        //                 this.topLevelItem.Quote.Size += it.Quote.Size;
        //                 this.topLevelItem.MMIDs.Add(it.Quote.MMID);
        //                 topLevel2QuoteWasChanged = true;
        //             }
        //         }
        //         // 4. Нет котировки - с помощью сортировки
        //         else
        //         {
        //             this.change = true;
        //             this.topLevelItem = this.GetTopAggregatedQuote(this.GetSortedList(), this.instrumentPrecision);
        //             topLevel2QuoteWasChanged = true;
        //         }
        //     }
        // }
    }

    this.change = true;


    return topLevel2QuoteWasChanged;
}

Level2Collection.prototype.GetSortedList = function (isBid)
{
    let keys = Object.keys(this.items);
    let keys_len = keys.length;
    if (keys_len !== this.itemsArr.length)
        this.itemsArr = Array(keys_len);

    for (let i = 0; i < keys_len; i++)
        this.itemsArr[i] = this.items[keys[i]];

    if (isBid)
        this.itemsArr.sort(Level2Collection.PriceComparerBid);
    else
        this.itemsArr.sort(Level2Collection.PriceComparerAsk);

    return this.itemsArr;
}

Level2Collection.PriceComparerBid = function (a, b)
{
    // if (isNaN(a.Quote.Price)) //#85713
    //     return 1;
    // if (isNaN(b.Quote.Price)) //#85713
    //     return -1;
    let xQuoteType = a.Quote ? a.Quote.QuoteType : null;
    let yQuoteType = b.Quote ? b.Quote.QuoteType : null;
    if (xQuoteType != Leve2QuoteType.None || yQuoteType != Leve2QuoteType.None)
        return Level2Collection.PriceComparerByType(xQuoteType, yQuoteType)

    if (a.Quote.Price < b.Quote.Price)
        return 1;
    return -1;
}

Level2Collection.PriceComparerAsk = function (a, b)
{

    // if (isNaN(a.Quote.Price))    //#85713
    //     return 1;
    // if (isNaN(b.Quote.Price))    //#85713
    //     return -1;

    let xQuoteType = a.Quote ? a.Quote.QuoteType : null;
    let yQuoteType = b.Quote ? b.Quote.QuoteType : null;
    if (xQuoteType != Leve2QuoteType.None || yQuoteType != Leve2QuoteType.None)
        return Level2Collection.PriceComparerByType(xQuoteType, yQuoteType)

    if (a.Quote.Price > b.Quote.Price)
        return 1;
    return -1;
}


Level2Collection.PriceComparerByType = function (xQuoteType, yQuoteType)
{
    //#42028 - если с сервера приходит -1, то необходимо такую котировку ставить в последнюю строку стакана.
    //#93376 - перевели с цены на дополнительный филд, так как цены 0 и -1 - это теперь валидные цены

    if (xQuoteType == yQuoteType)
        return 0;

    if (xQuoteType == Leve2QuoteType.Indicative)
        return -1;
    else if (xQuoteType == Leve2QuoteType.WithoutPrice)
        return 1;

    if (yQuoteType == Leve2QuoteType.Indicative)
        return 1;
    else if (yQuoteType == Leve2QuoteType.WithoutPrice)
        return -1;

}


var Level2ItemComparer = function (reverse, CompateType, filter)
{

    this.reverse = reverse;

    this.CompateType = CompateType || CompareType.Price;
    this.filter = filter || Filter.None;

}


export let Level2Item = function (qMsg, instrumentPrecision, cacheDataForComparer = true)
{
    /// <summary>
    /// alexb: закешировали некоторые данные, чтобы level2 comparer быстрей работал
    /// </summary>
    this.CachedRoundPrice;
    this.CachedDateTime;

    this.instrumentPrecision;

    /// <summary>
    /// список MMID для аггрегированной котировки, которая используется для генерации Level1 из Level2
    /// </summary>
    this.MMIDs;

    /// <summary>
    /// Ссылка на коировку
    /// </summary>
    this.Quote = null;

    this.Quote = qMsg;
    this.instrumentPrecision = instrumentPrecision;

    if (cacheDataForComparer && this.Quote != null)
    {
        this.UpdateRoundPrice();

        if (this.Quote != null)
            this.CachedDateTime = this.Quote.cTime.getTime();
    }
}

Level2Item.prototype.UpdateRoundPrice = function ()
{
    if (this.Quote === null)
        return;

    this.CachedRoundPrice = this.instrumentPrecision == -1 ?
        this.Quote.Price :
        Math.round(this.Quote.Price, this.instrumentPrecision);
}

// Level2Item.prototype.Copy = function ()
// {
//     let qMsg = new Quote2Message();
//     Quote.CopyMessageTo(qMsg);

//     let copy = new Level2Item(qMsg, instrumentPrecision);
//     copy.AggregatedVolume = AggregatedVolume;
//     copy.VWAPrice = VWAPrice;
//     copy.CachedRoundPrice = CachedRoundPrice;
//     return copy;
// }